import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo8/camarapepe.png";
import Imagen2 from "../../../images/modulo8/marcawalter.png";
import Imagen3 from "../../../images/modulo8/anforajuana.png";
import Imagen4 from "../../../images/modulo8/firmaolga.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo8 } from "../../../routes/Module8";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo8/Actividad 5.mp3";

const Actividad5 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "cámara secreta" },
    ans2: { value: "", valid: "", correctValue: "cédula" },
    ans3: { value: "", valid: "", correctValue: "ánfora" },
    ans4: { value: "", valid: "", correctValue: "firma" },
  });
  const infoUnidad = modulo8.content[0];
  const infoAct = modulo8.content[0].activities[4];
  const crumbs = [
    {
      title: modulo8.title,
      url: "/" + modulo8.url,
    },
    {
      title:
        modulo8.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo8.content[0].activities[5].name}`,
    linkNext: `${modulo8.url}/${modulo8.content[0].path}/${modulo8.content[0].activities[5].path}`,
    titlePrev: `${modulo8.content[0].activities[3].name}`,
    linkPrev: `${modulo8.url}/${modulo8.content[0].path}/${modulo8.content[0].activities[3].path}`,
  };

  const metadata = {
    color: modulo8.color,
    title: `${modulo8.title} - ${infoAct.name}`,
    name: modulo8.title,
  };

  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...answers, newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo8.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>
          Coloca la palabra o frase que falta en el espacio que corresponda.
        </li>
      </ul>
      <div className="row justify-content-center">
        <div className="col-lg-8 col-12 ms-4 mb-2">
          <Card>
            <div className="d-flex justify-content-around">
              <div>ánfora</div>
              <div>cámara secreta</div>
              <div>firma</div>
              <div>cédula</div>
            </div>
          </Card>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-lg-3 col-md-6">
          <img
            src={Imagen1}
            alt="derechos y deberes"
            className="img-fluid mt-4"
          />
          <Card>
            <p className="">
              Como el voto es secreto, para votar entramos a la{" "}
              <input
                type="text"
                className={
                  "input-text-sm form-control d-inline-block " +
                  answers.ans1.valid
                }
                value={answers.ans1.value}
                onChange={(event) => handleAnswers(event, "ans1")}
              />
            </p>
          </Card>
        </div>
        <div className="col-12 col-lg-3 col-md-6">
          <img
            src={Imagen2}
            alt="derechos y deberes"
            className="img-fluid mt-4"
          />
          <Card>
            <p>
              El papel en el que marcamos el voto se llama
              <input
                type="text"
                className={
                  "input-text-sm form-control d-inline-block " +
                  answers.ans2.valid
                }
                value={answers.ans2.value}
                onChange={(event) => handleAnswers(event, "ans2")}
              />
            </p>
          </Card>
        </div>
        <div className="col-12 col-lg-3 col-md-6">
          <img
            src={Imagen3}
            alt="derechos y deberes"
            className="img-fluid mt-4"
          />

          <Card>
            <p>
              Luego de marcar nuestro voto, lo depositamos en el
              <input
                type="text"
                className={
                  "input-text-sm form-control d-inline-block " +
                  answers.ans3.valid
                }
                value={answers.ans3.value}
                onChange={(event) => handleAnswers(event, "ans3")}
              />
            </p>
          </Card>
        </div>
        <div className="col-12 col-lg-3 col-md-6">
          <img
            src={Imagen4}
            alt="derechos y deberes"
            className="img-fluid mt-4"
          />

          <Card>
            <p>
              Para terminar, dejamos nuestra
              <input
                type="text"
                className={
                  "input-text-sm form-control d-inline-block me-2 " +
                  answers.ans4.valid
                }
                value={answers.ans4.value}
                onChange={(event) => handleAnswers(event, "ans4")}
              />
              y huella digital en el padrón electoral.
            </p>
          </Card>
        </div>
      </div>

      <div className="d-flex w-100 justify-content-end mb-4">
        <button
          className={`btn btn-${modulo8.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes y lean los textos. Ayude a
          responder. Si no recuerdan alguna palabra pueden volver a la Actividad
          2 de este módulo. Las respuestas son 1) cámara secreta, 2) cédula, 3)
          ánfora, 4) firma.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
